// GetPage returns data for rendering a custom page.
export const CustomPagesService_GetPageLazy = () =>
  import("./service.grpc").then((m) => m.CustomPagesService_GetPage);
CustomPagesService_GetPageLazy.method =
  "aysa_api.services.custom_pages.v1.CustomPagesService/GetPage" as const;
